import React, { useState, useEffect } from 'react'
import { FieldArray } from 'formik';
import {
  Box,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import RsltCostForm from './RsltCostForm';


const TechProductListForm = ({ formik }) => {
 
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
   if(formik.values.rsltCosts.length > 0){
    let totPrice = 0;
    formik.values.rsltCosts.forEach(cost =>{
      totPrice += parseInt(cost.costVal);
      setTotalPrice(totPrice)
    })
   }
  }, [ formik.values?.rsltCosts])
  


  return (
    <div>
      <FieldArray
        name="rsltCosts"
        render={arrayHelpers => (
          <Box>
            {formik.values?.rsltCosts.length === 0 ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="subtitle2" component="div">소요비용이 없습니다.</Typography>
              </Box>

            ) : (
              <TableContainer component={Box}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>종류</TableCell>
                      <TableCell>비용</TableCell>
                      <TableCell>비고</TableCell>
                      <TableCell>삭제</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formik.values?.rsltCosts.map((c, index) => {
                      
                      return (
                        <RsltCostForm
                          key={index}
                          cost={c}
                          index={index}
                          formik={formik}
                          handleRemove={() => arrayHelpers.remove(index)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
              <Box>
                <Typography variant="subtitle2" component="div" sx={{mr:2}}>총 가격:₩{totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
              </Box>
              <Box>
                <Button color="secondary" variant="outlined" onClick={() => arrayHelpers.push({
                  costTyp: '',
                  costVal: 0,
                  costDesc: '',
                })}>비용 추가
                </Button>
              </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
          </Box>

        )}

      >

      </FieldArray>

    </div>
  )
}



export default TechProductListForm